import {
    Select,
    SelectProps
} from '@cloudscape-design/components';
import React, { useEffect, useMemo, useState } from 'react';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { ItemCountry } from '../../resources/types';
// Note: Assuming OptionDefinition type is available globally if needed,
// but for ItemGroupType, we define the full structure.



// --- PROPS INTERFACES ---

// Base props common to both modes
interface SelectCountryBaseProps {
    visible?: boolean;
    showZero?: boolean;
    width?: number;
    readonly?: boolean;
    tokenLimit?: number;
    hideTokens?: boolean;
    idCountry?: number;
}

// 1. When single = true
interface SelectCountryProps extends SelectCountryBaseProps {
    value?: number; // Single ID
    width?: number;
    onSelect?: (selected: number | null) => void; // Returns ID or null
}

export type SelectGroupTypeProps =
    | SelectCountryProps

// -----------------------------
// COMPONENT IMPLEMENTATION
// -----------------------------

const SelectCountry: React.FC<SelectCountryProps> = (props) => {
    const {
        width = 200,
        value,
        readonly,
        visible,
        tokenLimit = 3,
        hideTokens = false,
        showZero = false,
        idCountry,
        onSelect
    } = props;

    const { data } = useGlobalState();
    if (!data || !data.groupTypes) return <></>;

    // State for Single Selection (holds the selected object)
    const [selectedSingle, setSelectedSingle] = useState<ItemCountry | null>(null);


    // --- Mapped Group Types (Options List) ---

    // Memoize the calculation of available options
    const mappedCountries: ItemCountry[] = useMemo(() => {
        if (!data?.countries) return [];

        const items = data.countries.map((c: ItemCountry) => ({
            ...c,
            value: c.idCountry.toString(),
            label: c.country
        }));

        // Partition country 112 to the top while preserving order for the rest
        return items.sort((a: ItemCountry, b: ItemCountry) => (a.idCountry === 112 ? -1 : b.idCountry === 112 ? 1 : 0));
    }, [data?.countries]);


    // --- Initialization & Value Sync Effect ---

    useEffect(() => {
        if (!value) {
            setSelectedSingle(null);
            return;
        }

        // SINGLE MODE: Value is a number (ID)
        const id = value as number;
        const match = mappedCountries?.find(gt => gt.idCountry === id) || null;
        setSelectedSingle(match);


    }, [value, data.countries, mappedCountries]);


    // --- Single Select Handler ---
    const handleSingleChange: SelectProps['onChange'] = ({ detail }) => {
        const selectedOption = detail.selectedOption as ItemCountry | null;

        setSelectedSingle(selectedOption);

        if (onSelect) {
            const selectedId = selectedOption?.idCountry ?? null; // Extract ID
            // Assert the function signature to number | null
            (onSelect as (selected: number | null) => void)(selectedId);
        }
    };

    // --- Multi Select Handler ---

    // --- Rendering ---

    //const placeholder = single ? "Seleccionar grupo" : "Seleccionar grupos";


    const placeholder = "Seleccionar país";

    const wrapperStyle: React.CSSProperties = {
        width: width > 0 ? `${width}px` : '100%'
    };
    return (
        <div style={wrapperStyle}>
            <Select
                readOnly={readonly}
                placeholder={placeholder}
                selectedOption={selectedSingle}
                options={mappedCountries}
                onChange={handleSingleChange}
                filteringType="auto"
            />

        </div>
    );
};

export default SelectCountry;